import Vue from "vue";

const ID_TOKEN_KEY = "id_token_client";
const userProfile = "$che";

export const getToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};

export const saveToken = async (token) => {
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const destroyToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
    Vue.prototype.$v_session.remove(userProfile);
};

export const saveUserData = (udata) => {
    Vue.prototype.$v_session.set(userProfile, JSON.stringify(udata));
};

export const getUserData = () => {
    let userData = Vue.prototype.$v_session.get(userProfile);
    if (userData && userData !== undefined) {
        return JSON.parse(userData);
    }
    return false;
};

export default { getToken, saveToken, destroyToken, saveUserData, getUserData };
